import { Redirect } from 'react-router-dom';

import { ROUTE_ARTICLES, ROUTE_DASHBOARD_REWARDS } from '../../../config/routes';
import { useFirebaseAuth } from '../../../../global/FirebaseProvider/FirebaseProvider';

// `/` is the post-login landing: signed-in users go to Rewards, signed-out
// visitors keep the public Articles page.
const HomeRedirect = () => {
  const { isSignedIn, isLoading } = useFirebaseAuth();

  if (isLoading) {
    return null;
  }

  return <Redirect to={isSignedIn ? ROUTE_DASHBOARD_REWARDS : ROUTE_ARTICLES} />;
};

export default HomeRedirect;
